import React from "react";

import { queries } from "lib/build/dashboards/basic-health/queries";
import { Status } from "lib/build/forms/basic-health/patientCondition";

import { SafeFormattedMessage } from "src/common/components/SafeFormattedMessage";
import { useLastEventValueByQuery } from "src/features/events";
import { shortStatusMessages } from "src/modules/basic-health/messages";

export const ShortStatus: React.FunctionComponent = () => {
	const status =
		useLastEventValueByQuery<Status>(queries.patientStatus) || Status.NEW;
	return (
		<SafeFormattedMessage
			messages={shortStatusMessages}
			messageKey={status}
		/>
	);
};
